<template>
  <router-view />
  <Idle v-if="userStore.loggedIn" />
</template>

<style lang="scss">
@import 'src/scss/app.scss';
</style>
<script setup lang="ts">
import Idle from '@/Idle.vue';
import { useUserStore } from '@/stores/user';

const userStore = useUserStore();
</script>
